// extracted by mini-css-extract-plugin
export default {"label":"lsf-label","label_margins":"lsf-label_margins","label_empty":"lsf-label_empty","label_hidden":"lsf-label_hidden","label_clickable":"lsf-label_clickable","label_solid":"lsf-label_solid","label_selected":"lsf-label_selected","label__hotkey":"lsf-label__hotkey","label__text":"lsf-label__text"};
    if(module.hot) {
      // 1732531528764
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  